<template>
    <div>
        <MainNavigation page-name="My Class" :routeIndex="routeIndex" />
        <NotificationBar msg-text="Add your student list" />
        <div>
            <h2>Class Info</h2>
            <ClassItem v-if="currentClass" :editMode="false" :classItem="currentClass" :itemType="'static'" />
        </div>
        <hr />
        <div class="number-students-list">
            <h2>Enter Student Names</h2>
            <div class="flex-container-row">
                <div class="input-counter">
                    <span class="material-icons-round button" @click="removeAStudent">remove_circle</span>
                    <input class="clock__input--number" type="number" v-model="studentNumber"
                        @change="updateStudentCount" id="time-limit-number" />
                    <span class="material-icons-round" @click="addAStudent">add_circle</span>
                </div>
                <span><em>Enter number of students</em></span>
            </div>
        </div>
        <p v-if="validArray.filter((item) => item > 0).length != 0"
            style="display: flex; font-weight: bold; font-width: 16px; color: #eb5757">
            See errors below.
        </p>
        <div v-if="validArray.filter((item) => item > 0).length != 0"
            :class="{ error: validArray.filter((item) => item > 0).length != 0 }" style="padding: 1rem">
            <!-- Duplicate name with no nickname -->
            <p v-if="validArray.includes(1)" class="error-message">
                <img src="@/assets/error_outline_24px.svg" class="error-icon" />
                Student must have unique names. Please remove duplicate names.
            </p>

            <!-- Duplicate name with same nickname -->
            <p v-if="validArray.includes(2)" class="error-message">
                <img src="@/assets/error_outline_24px.svg" class="error-icon" />
                For students with identical names, add a unique nickname.
            </p>

            <!-- Invalid name format -->
            <p v-if="validArray.includes(3)" class="error-message">
                <img src="@/assets/error_outline_24px.svg" class="error-icon" />
                Names must use this format: First name and last initial (e.g., John D)
            </p>
        </div>
        <ul class="student-list">
            <li v-for="(student, index) in classList" :key="index" :class="{ error: validArray[index] != 0 }">
                <div class="student-form">
                    <h4>Student {{ index + 1 }}</h4>
                    <span class="material-icons-round button" @click="removeStudent(index)">remove_circle</span>
                </div>

                <div class="name-inputs">
                    <input type="text" maxlength="35" placeholder="First name" v-model="student.studentFirstName" />
                    <input type="text" maxlength="1" placeholder="Last initial" v-model="student.studentLastInitial" />
                </div>

                <div v-if="student.isNickNameOpen">
                    <div class="student-form">
                        <h4>Nickname</h4>
                        <span class="material-icons-round button" @click="closeNickname(student)">remove_circle</span>
                    </div>
                    <div class="nickname-form">
                        <input type="text" maxlength="35" placeholder="Nickname" v-model="student.studentNickname" />
                    </div>
                </div>

                <button style="margin: 1rem 0" class="add-nickname-button" v-if="!student.isNickNameOpen"
                    @click="student.isNickNameOpen = true">
                    <span class="material-icons-round">add_circle</span>
                    Add a Nickname
                </button>
            </li>
        </ul>

        <div class="add-student" style="margin-bottom: 2rem">
            <button @click="addAStudent()" class="add-student-button">
                <span class="material-icons-round">add_circle</span>
                <span>Add a Student</span>
            </button>
        </div>

        <button class="save-button" @click="checkIfValid()">Save</button>
        <div class="write-student-name-container" style="display: none">
            <p>Add your student list here with a line break after name:</p>
            <textarea v-model="studentEntry" placeholder="Add one student per line" rows="20"></textarea>
            <button class="save-button" @click="checkIfValid()">Save</button>
        </div>
    </div>
</template>

<script>
    import MainNavigation from "../components/MainNavigation.vue";
    import NotificationBar from "../components/NotificationBar.vue";
    import ClassItem from "../components/ClassItem.vue";

    export default {
        name: "StudentList",
        components: {
            MainNavigation,
            NotificationBar,
            ClassItem,
        },
        props: ["name", "routeIndex"],
        data() {
            return {
                studentEntry: null,
                studentNumber: 0,
                showStudentList: true,
                classList: [],
            };
        },
        computed: {
            allClasses() {
                return this.$store.state.allClasses;
            },
            currentClass() {
                const result = this.$store.state.allClasses.filter((response) => {
                    return response.classInfo.nickname === this.$route.params.name;
                });
                // console.log(result, this.$route.params.name);
                return result[0];
            },
            allStudents() {
                return this.$store.state.studentList;
            },
            validArray() {
                const tempArray = Array(this.classList.length).fill(0);

                // Check format: First name + Last Initial (e.g. John D)
                for (let i = 0; i < this.classList.length; i++) {
                    const student = this.classList[i];
                    const first = student.studentFirstName.trim();
                    const last = student.studentLastInitial.trim();

                    // Check empty name
                    if (!first && !last) {
                        tempArray[i] = 0;
                        continue;
                    }

                    const firstNameValid = /^[a-zA-Z][a-zA-Z'’-]*$/.test(first);
                    const lastInitialValid = /^[a-zA-Z]$/.test(last);

                    if (!firstNameValid || !lastInitialValid) {
                        tempArray[i] = 3;
                    }
                }

                // Check for duplicate names and nicknames
                for (let i = 0; i < this.classList.length; i++) {
                    const s1 = this.classList[i];
                    const name1 = `${s1.studentFirstName} ${s1.studentLastInitial}`;

                    for (let j = i + 1; j < this.classList.length; j++) {
                        const s2 = this.classList[j];
                        const name2 = `${s2.studentFirstName} ${s2.studentLastInitial}`;

                        if (name1 === name2 && s1.studentFirstName && s2.studentFirstName) {
                            if (s1.studentNickname && s2.studentNickname && s1.studentNickname === s2.studentNickname) {
                                tempArray[i] = tempArray[j] = 2; // duplicate names + duplicate nicknames
                            } else if (!s1.studentNickname && !s2.studentNickname) {
                                tempArray[i] = tempArray[j] = 1; // duplicate names + no nicknames
                            }
                        }
                    }
                }
                return tempArray;
            },
        },
        methods: {
            checkIfValid: function () {
                let flag = true;

                // Any format or duplicate errors?
                if (this.validArray.includes(3)) flag = false;
                if (this.validArray.filter(item => item > 0).length !== 0) flag = false;

                // Any students missing first name or last initial?
                if (this.classList.some(item => item.studentFirstName.trim() === "" || item.studentLastInitial.trim() === "")) {
                    flag = false;
                }

                // No students at all?
                if (this.classList.length == 0) flag = false;

                if (flag) this.saveClass();
            },
            saveClass: function () {
                const studentListFormatted = this.classList.map(s => ({
                    ...s,
                    studentName: `${s.studentFirstName} ${s.studentLastInitial}`
                }));

                this.$store.commit("SEND_MESSAGE", {
                    data: {
                        studentList: studentListFormatted,
                        classId: this.$store.state.currentClass.classId,
                    },
                    opCode: this.$store.state.opCodes.SetStudentList,
                });

                this.$store.commit("SEND_MESSAGE", {
                    data: this.currentClass.classId,
                    opCode: this.$store.state.opCodes.PastSessionsCount,
                });

                this.$router.push({
                    name: "class-info",
                    params: { name: this.currentClass.classInfo.nickname },
                }).then(()=> {
                    window.location.reload();
                });
            },
            removeAStudent() {
                if (this.studentNumber === 0) return;
                this.studentNumber--;
                this.classList.splice(this.studentNumber, 1);
            },
            addAStudent() {
                this.studentNumber++;
                this.classList.push({
                    isNickNameOpen: false,
                    studentName: "",
                    studentFirstName: "",
                    studentLastInitial: "",
                    studentNickname: "",
                });
            },
            updateStudentCount() {
                var count = this.studentNumber;
                if (count < this.classList.length) {
                    this.classList.splice(count, this.classList.length - count);
                } else {
                    var countDiff = count - this.classList.length;
                    for (let i = 0; i < countDiff; i++) {
                        this.classList.push({
                            isNickNameOpen: false,
                            studentName: "",
                            studentFirstName: "",
                            studentLastInitial: "",
                            studentNickname: "",
                        });
                    }
                }
            },
            closeNickname(student) {
                student.isNickNameOpen = false;
                student.studentNickname = "";
            },
            removeStudent(index) {
                this.classList.splice(index, 1);
                this.studentNumber--;
            },
        },
    };
</script>

<style lang="scss">
    /* /* ../assets/scss/_student-list.scss */
</style>